export const RWA_CUSTODY_VAULT_721_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "onERC721Received",
    "outputs": [
      {
        "internalType": "bytes4",
        "name": "",
        "type": "bytes4"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "collection",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "recipient",
        "type": "address"
      }
    ],
    "name": "releaseErc721To",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_CUSTODY_VAULT_721_BYTECODE = "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";

export const RWA_CUSTODY_VAULT_721_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\npragma solidity ^0.8.19;\n\n/**\n * @title RwaCustodyVault721\n * @notice Per–authorized-tokenizer custody vault: accepts ERC-721s via `safeTransferFrom` (IERC721Receiver).\n *         Only `owner` may call `releaseErc721To` to move a held NFT out (redemption / delivery). Transfer\n *         `owner` to a multisig or admin-controlled wallet for operational policy. Each tokenizer deploys their own instance.\n */\ninterface IERC721Minimal {\n    function safeTransferFrom(address from, address to, uint256 tokenId) external;\n}\n\ncontract RwaCustodyVault721 {\n    /// @dev bytes4(keccak256(\"onERC721Received(address,address,uint256,bytes)\"))\n    bytes4 private constant _ERC721_RECEIVED = 0x150b7a02;\n\n    address public owner;\n\n    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);\n\n    modifier onlyOwner() {\n        require(msg.sender == owner, \"Only owner\");\n        _;\n    }\n\n    constructor() {\n        owner = msg.sender;\n        emit OwnershipTransferred(address(0), msg.sender);\n    }\n\n    function transferOwnership(address newOwner) external onlyOwner {\n        require(newOwner != address(0), \"Zero owner\");\n        emit OwnershipTransferred(owner, newOwner);\n        owner = newOwner;\n    }\n\n    function onERC721Received(address, address, uint256, bytes calldata) external pure returns (bytes4) {\n        return _ERC721_RECEIVED;\n    }\n\n    /// @notice Move an NFT held by this vault to `recipient`. Callable only by `owner` (e.g. tokenizer ops or admin key).\n    function releaseErc721To(address collection, uint256 tokenId, address recipient) external onlyOwner {\n        require(recipient != address(0), \"Zero recipient\");\n        IERC721Minimal(collection).safeTransferFrom(address(this), recipient, tokenId);\n    }\n}\n";

export const RWA_CUSTODY_VAULT_721 = {
  contractName: "RwaCustodyVault721",
  abi: RWA_CUSTODY_VAULT_721_ABI,
  abiJson: JSON.stringify(RWA_CUSTODY_VAULT_721_ABI),
  bytecode: RWA_CUSTODY_VAULT_721_BYTECODE,
  mintFunctionName: "",
  soliditySource: RWA_CUSTODY_VAULT_721_SOLIDITY_SOURCE,
  sourceFileName: "RwaCustodyVault721.sol"
};
